/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PathAlertsComponent} from './component/path-alerts.component';
import {StatusDotModule} from '../status-dot/status-dot.module';
import {PipesModule} from '../pipes/pipes.module';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [PathAlertsComponent],
    exports: [
        PathAlertsComponent
    ],
    imports: [
        CommonModule,
        StatusDotModule,
        PipesModule,
        TooltipModule
    ]
})
export class PathAlertsModule {
}
